import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = { isVisible: false, isFetching: false };

const open = () => ({
  isVisible: true,
  isFetching: false,
});

const close = () => initialState;

const startFetching = () => ({
  isVisible: true,
  isFetching: true,
});

export default createReducer(initialState, {
  [types.OPEN_EXPORT_STATS_MODAL]: open,
  [types.CLOSE_EXPORT_STATS_MODAL]: close,
  [types.EXPORT_QUESTION_MODEL_STATISTIC]: startFetching,
});
